namespace TabAurous.ECommerce {
    export namespace ECommRefundService {
        export const baseUrl = 'ECommerce/ECommRefund';

        export declare function Create(request: Serenity.SaveRequest<ECommRefundRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ECommRefundRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ECommRefundRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<ECommRefundRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function RefundOrderList(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<Finance.PartyBalanceRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "ECommerce/ECommRefund/Create",
            Update = "ECommerce/ECommRefund/Update",
            Delete = "ECommerce/ECommRefund/Delete",
            Retrieve = "ECommerce/ECommRefund/Retrieve",
            List = "ECommerce/ECommRefund/List",
            RefundOrderList = "ECommerce/ECommRefund/RefundOrderList"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'RefundOrderList'
        ].forEach(x => {
            (<any>ECommRefundService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
